import React from 'react';
import { PageTitleBanner } from '@goodfynd/react-web.layout.page-title-banner';
import { LoadingTruck } from '@goodfynd/react-web.ui.loading';

import { useEvent } from '../../../context/EventContext';
import { useRequireAuth } from '../../../hooks/useRequireAuth';
import { getLotName } from '../../../utils/event-util';
import { Footer } from '../Footer';
import { Header } from '../Header';

import { StyledPageContainer } from './styles';
import type { LayoutWithHeaderProps } from './types';
export default function LayoutWithHeader({
  bannerContainerCss,
  children,
  authRequired,
  showLotName,
  allowedRoles,
  ...props
}: LayoutWithHeaderProps): JSX.Element {
  const isLoggedIn = useRequireAuth({ allowedRoles, authRequired });
  const { eventItem, isLoading } = useEvent();
  if (authRequired && !isLoggedIn) {
    return <></>;
  }

  return (
    <StyledPageContainer css={{ paddingTop: 64 }}>
      <Header />
      <>
        {typeof props.bannerTitle === 'string' ? (
          <PageTitleBanner
            containerCss={bannerContainerCss}
            title={props.bannerTitle}
            subtitle={
              showLotName ? getLotName(eventItem) : props.bannerSubTitle
            }
          />
        ) : (
          props.bannerTitle
        )}

        {isLoading ? <LoadingTruck /> : children}
      </>
      <Footer />
    </StyledPageContainer>
  );
}
